








import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter } from 'vuex-class'

import YourAccountHelperComponents1MainPage from './service-for-your-account-helper-components/your-account-helper-components-1-main-page.vue'

import DigitalCurrency8WatchVideoIntroduction from '../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-8-watch-video-introduction.vue'

const namespace = 'digitalCurrency'

@Component({
  components: {
    YourAccountHelperComponents1MainPage,
    DigitalCurrency8WatchVideoIntroduction
  }
})
class YourAccount1 extends Vue {
  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any

}

export default YourAccount1


